// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}


html {
  background-color: #FFF2F1 !important;
}

.label {
  color: #190d00;
}

.button.is-link {
  background-color: #7f4400 !important;
}

.button.is-link:hover {
  background-color: #b25f00 !important;
}


.button.is-link:active {
  background-color: #995100 !important;
}

.button.is-link.is-light {
  color: #7f4400 !important;
  background-color: #FFF2F1 !important;
  border: 1px solid #7f4400 !important;

}


.button.is-link.is-light:hover {
  color: #b25f00 !important;
  background-color: #FFF2F1 !important;
  border: 1px solid #b25f00 !important;

}

.button.is-link.is-light:active {
  color: #b25f00 !important;
  background-color: #FFF2F1 !important;
  border: 1px solid #30336b !important;

}


/**
CUSTOM CLASSES
*/


.header-logo {
  margin: auto;
}

.navbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 600px) {
  .navbar
  {
    display: none;

  }
}

.lt-header-logo {
  display: flex;
}



.lt-header-profile-link {
  display: flex;
}


@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.lt-header-profile-link {
  cursor: pointer;
}


@media (max-width: 600px) {

  .hero-foot,
  .hero-head {
    max-height: 42px;
  }

  .header-logo, .lt-header-profile-link   {
    display: none;
  }

  .lt-logo-header
  {
     /**
     height: 46px;
     */
     display: none;
  }

   
}

@media (min-width: 601px) {


  .lt-logout-desktop-icon  {
    display: none !important;
  }

  .lt-logo-header
  {
     height: 115px;
  }

}


.lt-xp-form-login-notification-area
{
  text-align: center;

}


.lt-info
{
  color: #dfe0df !important;
  border-color: #dfe0df !important;
  border-top: none !important;
  border-bottom: none !important;
  border-right: none !important;
  align-self: center !important;
  align-items: center !important;
  
}


.lt-info:hover
{
  color: #dfe0df !important;
  border-color: #dfe0df !important;
  background-color: #927200 !important;
  align-self: center !important;
  align-items: center !important;


 
}

.lt-info:active
{
  color: #dfe0df !important;
  border-color: #dfe0df !important;
background-color: #38beac !important;
align-self: center !important;
align-items: center !important;


}

.box {
  cursor: pointer;
  transition: max-height 0.3s ease-out;
  overflow: hidden;
}

.box.collapsed .icon {
  display: none;
}

.box.collapsed .progress {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,oCAAoC;;AAEtC;;;AAGA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,oCAAoC;;AAEtC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,oCAAoC;;AAEtC;;;AAGA;;CAEC;;;AAGD;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE;;IAEE,aAAa;;EAEf;AACF;;AAEA;EACE,aAAa;AACf;;;;AAIA;EACE,aAAa;AACf;;;AAGA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,eAAe;AACjB;;;AAGA;;EAEE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;;KAEG;;MAEC;KACD,aAAa;EAChB;;;AAGF;;AAEA;;;EAGE;IACE,wBAAwB;EAC1B;;EAEA;;KAEG,aAAa;EAChB;;AAEF;;;AAGA;;EAEE,kBAAkB;;AAEpB;;;AAGA;;EAEE,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;;AAEhC;;;AAGA;;EAEE,yBAAyB;EACzB,gCAAgC;EAChC,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;;;;AAIhC;;AAEA;;EAEE,yBAAyB;EACzB,gCAAgC;AAClC,oCAAoC;AACpC,6BAA6B;AAC7B,8BAA8B;;;AAG9B;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\nhtml {\n  background-color: #FFF2F1 !important;\n}\n\n.label {\n  color: #190d00;\n}\n\n.button.is-link {\n  background-color: #7f4400 !important;\n}\n\n.button.is-link:hover {\n  background-color: #b25f00 !important;\n}\n\n\n.button.is-link:active {\n  background-color: #995100 !important;\n}\n\n.button.is-link.is-light {\n  color: #7f4400 !important;\n  background-color: #FFF2F1 !important;\n  border: 1px solid #7f4400 !important;\n\n}\n\n\n.button.is-link.is-light:hover {\n  color: #b25f00 !important;\n  background-color: #FFF2F1 !important;\n  border: 1px solid #b25f00 !important;\n\n}\n\n.button.is-link.is-light:active {\n  color: #b25f00 !important;\n  background-color: #FFF2F1 !important;\n  border: 1px solid #30336b !important;\n\n}\n\n\n/**\nCUSTOM CLASSES\n*/\n\n\n.header-logo {\n  margin: auto;\n}\n\n.navbar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n@media (max-width: 600px) {\n  .navbar\n  {\n    display: none;\n\n  }\n}\n\n.lt-header-logo {\n  display: flex;\n}\n\n\n\n.lt-header-profile-link {\n  display: flex;\n}\n\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.lt-header-profile-link {\n  cursor: pointer;\n}\n\n\n@media (max-width: 600px) {\n\n  .hero-foot,\n  .hero-head {\n    max-height: 42px;\n  }\n\n  .header-logo, .lt-header-profile-link   {\n    display: none;\n  }\n\n  .lt-logo-header\n  {\n     /**\n     height: 46px;\n     */\n     display: none;\n  }\n\n   \n}\n\n@media (min-width: 601px) {\n\n\n  .lt-logout-desktop-icon  {\n    display: none !important;\n  }\n\n  .lt-logo-header\n  {\n     height: 115px;\n  }\n\n}\n\n\n.lt-xp-form-login-notification-area\n{\n  text-align: center;\n\n}\n\n\n.lt-info\n{\n  color: #dfe0df !important;\n  border-color: #dfe0df !important;\n  border-top: none !important;\n  border-bottom: none !important;\n  border-right: none !important;\n  align-self: center !important;\n  align-items: center !important;\n  \n}\n\n\n.lt-info:hover\n{\n  color: #dfe0df !important;\n  border-color: #dfe0df !important;\n  background-color: #927200 !important;\n  align-self: center !important;\n  align-items: center !important;\n\n\n \n}\n\n.lt-info:active\n{\n  color: #dfe0df !important;\n  border-color: #dfe0df !important;\nbackground-color: #38beac !important;\nalign-self: center !important;\nalign-items: center !important;\n\n\n}\n\n.box {\n  cursor: pointer;\n  transition: max-height 0.3s ease-out;\n  overflow: hidden;\n}\n\n.box.collapsed .icon {\n  display: none;\n}\n\n.box.collapsed .progress {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
